import React from 'react';
import Homepage from './homepage';

import '../styles/index.css';

class App extends React.Component {
	render() {
		return (
			<div>
				<Homepage></Homepage>
			</div>
		);
	}
}

export default App;